import { canViewKitchenOrders } from "@/lib/permissions";

/** Navigation label keys for i18n (see i18n/locales/*.json nav.*). */
export const MENUS = [
  {
    labelKey: "nav.operations",
    items: [
      { labelKey: "nav.pointOfSale", to: "/pos", permission: "pos.view" },
      // { labelKey: "nav.heldBills", to: "/pos/held-bills", permission: "pos.view" },
      { labelKey: "simple.dayOpen", to: "/pos", permission: "pos.view" },
      { labelKey: "simple.dayClose", to: "/reports/z-report", permission: "reports.view" },
      { labelKey: "nav.tableManagement", to: "/tables", permission: "pos.view" },
      { labelKey: "nav.reservations", to: "/reservations", permission: "pos.view" },
      { labelKey: "nav.kitchenOrders", to: "/kds", accessCheck: canViewKitchenOrders },
      { labelKey: "nav.delivery", to: "/delivery", permission: "delivery.view" },
      { labelKey: "nav.onlineOrders", to: "/online/orders", permission: "online.orders.view" },
      { labelKey: "nav.waiterOrders", to: "/waiter", permission: "waiter.view" },
      { labelKey: "nav.xReport", to: "/reports/x-report", permission: "reports.view" },
      { labelKey: "nav.zReport", to: "/reports/z-report", permission: "reports.view" },
    ],
  },
  {
    labelKey: "nav.masters",
    items: [
      { labelKey: "nav.mainMenu", to: "/masters/main-menu", permission: "masters.view" },
      { labelKey: "nav.subMenu", to: "/masters/sub-menu", permission: "masters.view" },
      { labelKey: "nav.menuItem", to: "/masters/menu-item", permission: "masters.view" },
      { labelKey: "nav.tables", to: "/masters/tables", permission: "masters.view" },
      { labelKey: "nav.tableDesigner", to: "/masters/table-designer", permission: "masters.view" },
      { labelKey: "nav.customers", to: "/masters/customers", permission: "masters.view" },
      { labelKey: "nav.suppliers", to: "/masters/suppliers", permission: "masters.view" },
      { labelKey: "nav.deliveryAreas", to: "/masters/delivery-areas", permission: "masters.view" },
      { labelKey: "nav.deliveryPersons", to: "/masters/delivery-persons", permission: "masters.view" },
      { labelKey: "nav.kitchenNotes", to: "/masters/kitchen-notes", permission: "masters.view" },
      { labelKey: "nav.kotMaster", to: "/masters/kot", permission: "masters.view" },
      // { labelKey: "nav.promotions", to: "/masters/promotions", permission: "masters.view" },
      // { labelKey: "nav.inventory", to: "/inventory", permission: "masters.view" },
    ],
  },
  // Accounts menu hidden from top nav
  // {
  //   labelKey: "nav.accounts",
  //   items: [
  //     { labelKey: "nav.schedules", to: "/accounts/schedules", permission: "accounts.view" },
  //     { labelKey: "nav.accountsChart", to: "/accounts/accounts", permission: "accounts.view" },
  //     { labelKey: "nav.receiptVoucher", to: "/accounts/receipt", permission: "accounts.view" },
  //     { labelKey: "nav.paymentVoucher", to: "/accounts/payment", permission: "accounts.view" },
  //     { labelKey: "nav.journalVoucher", to: "/accounts/journal", permission: "accounts.view" },
  //     { labelKey: "nav.contraVoucher", to: "/accounts/contra", permission: "accounts.view" },
  //     { labelKey: "nav.debitNote", to: "/accounts/debit-note", permission: "accounts.view" },
  //     { labelKey: "nav.creditNote", to: "/accounts/credit-note", permission: "accounts.view" },
  //     { labelKey: "nav.ledgerReport", to: "/accounts/ledger", permission: "accounts.view" },
  //     { labelKey: "nav.trialBalance", to: "/accounts/trial-balance", permission: "accounts.view" },
  //     { labelKey: "nav.profitLoss", to: "/accounts/profit-loss", permission: "accounts.view" },
  //     { labelKey: "nav.balanceSheet", to: "/accounts/balance-sheet", permission: "accounts.view" },
  //     { labelKey: "nav.cashBook", to: "/accounts/cash-book", permission: "accounts.view" },
  //     { labelKey: "nav.bankBook", to: "/accounts/bank-book", permission: "accounts.view" },
  //     { labelKey: "nav.dayBook", to: "/accounts/day-book", permission: "accounts.view" },
  //   ],
  // },
  {
    labelKey: "nav.reports",
    items: [
      { labelKey: "nav.reportCenter", to: "/reports", permission: "reports.view" },
      { labelKey: "nav.posBillHistory", to: "/reports/bill-history", permission: "reports.view" },
    ],
  },
  {
    labelKey: "nav.administration",
    items: [
      { labelKey: "nav.users", to: "/admin/users", permission: "administration.view" },
      { labelKey: "nav.roles", to: "/admin/roles", permission: "administration.view" },
      { labelKey: "nav.auditLog", to: "/admin/audit-log", permission: "administration.view" },
      { labelKey: "nav.counters", to: "/admin/counters", permission: "administration.view" },
      { labelKey: "nav.aggregators", to: "/admin/aggregators", permission: "administration.view" },
      { labelKey: "nav.onlineStore", to: "/admin/online-store", permission: "online.orders.view" },
      { labelKey: "nav.whatsapp", to: "/admin/whatsapp", permission: "administration.view" },
      { labelKey: "nav.loyalty", to: "/admin/loyalty", permission: "administration.view" },
      { labelKey: "nav.tips", to: "/admin/tips", permission: "administration.view" },
      { labelKey: "nav.printers", to: "/admin/printers", permission: "administration.view" },
      { labelKey: "nav.companySetup", to: "/admin/company", permission: "administration.view" },
      { labelKey: "nav.restaurantSetup", to: "/admin/restaurant", permission: "administration.view" },
      { labelKey: "nav.taxSettings", to: "/admin/tax", permission: "administration.view" },
      { labelKey: "nav.generalSettings", to: "/admin/general", permission: "administration.view" },
    ],
  },
];
